import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackClick } from "@/lib/api";

export const useClickTracking = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        const onClick = (e) => {
            const anchor = e.target.closest?.("a[href]");
            if (anchor) trackClick(anchor.getAttribute("href"), pathname);
        };
        document.addEventListener("click", onClick, true);
        return () => document.removeEventListener("click", onClick, true);
    }, [pathname]);
};
